module.exports = __webpack_public_path__ + "static/media/logo-antiaging.36e516e8.svg";